import styled from '@emotion/styled'
import { OrderItem } from 'shop/types/cart'
import CartItem from './CartItem'
import { CartType } from '../Cart'

interface Props {
  items: OrderItem[]
  type: CartType
  onQuantityChange?: (orderItem: OrderItem, delta: number) => Promise<void>
  pendingDeltas?: Record<string, number>
}

const CartItemList = ({
  items,
  type,
  onQuantityChange,
  pendingDeltas
}: Props) => {
  return (
    <CartItemsList data-testid='cart-items'>
      {items.map((orderItem, index) => (
        <CartItem
          key={`${orderItem.variantId}-${index}`}
          orderItem={orderItem}
          type={type}
          onQuantityChange={onQuantityChange}
          isLast={index === items.length - 1}
          pendingDeltas={pendingDeltas}
        />
      ))}
    </CartItemsList>
  )
}

const CartItemsList = styled.ul({
  listStyle: 'none',
  margin: 0,
  padding: 0
})

export default CartItemList
